var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as React from 'react';
import { isNil, isTargetChildOfElementId, KeyAttributeValue, logToConsole, useCheckIsMounted, usePrevious, } from '@hawkins/helpers';
import { useFormGroupContext } from '../../../formGroup';
import { useId } from '../../../hooks';
import { A11Y_HAWKINS_DROPDOWN_DESCRIBES_ID, A11Y_HAWKINS_DROPDOWN_LIST_ID, A11Y_HAWKINS_DROPDOWN_TRIGGER_LABEL_ID, creatableFooterDataSelector, DEFAULT_GET_OPTION_DISABLED, DEFAULT_GET_OPTION_LABEL, DEFAULT_GET_OPTION_VALUE, DEFAULT_ON_CREATE_OPTION_FROM_RAW_VALUE, DROPDOWN_ON_CREATE_OPTION_NULL, dropdownDisplayName, GET_DEFAULT_FILTER_OPTIONS, STABLE_EMPTY_ARRAY, } from '../../dropdown.constants';
import { checkDropdownOptionsDeepEqual, checkRawValuesDeepEqual, dedupeOptions, normalizeRawValue } from '../../util';
import { useCoerceFilterOptionsAsyncProps } from './useCoerceFilterOptionsAsyncProps';
import { useDropdownPropWarnings } from './useDropdownPropWarnings';
/** For clarity, a consistent variable to use when clearing out internalOptions to represent that
 * optionsProp should be taken as priority over internalOptions */
var INTERNAL_OPTIONS_NOT_USED = null;
export function useDropdownActions(props, translate) {
    var _this = this;
    // props
    var autoComplete = props.autoComplete, _a = props.checkOptionsEqual, checkOptionsEqual = _a === void 0 ? checkDropdownOptionsDeepEqual : _a, _b = props.checkRawValuesEqual, checkRawValuesEqual = _b === void 0 ? checkRawValuesDeepEqual : _b, _c = props.clearSearchOnClose, clearSearchOnClose = _c === void 0 ? false : _c, _d = props.clearSearchOnSelect, clearSearchOnSelect = _d === void 0 ? false : _d, creatable = props.creatable, disabledProp = props.disabled, filterOptionsProp = props.filterOptions, filterOptionsAsyncProp = props.filterOptionsAsync, _e = props.getOptionLabel, getOptionLabel = _e === void 0 ? DEFAULT_GET_OPTION_LABEL : _e, _f = props.getOptionDisabled, getOptionDisabled = _f === void 0 ? DEFAULT_GET_OPTION_DISABLED : _f, _g = props.getOptionValue, getOptionValueProp = _g === void 0 ? DEFAULT_GET_OPTION_VALUE : _g, groupBy = props.groupBy, idProp = props.id, initialIsOpen = props.initialIsOpen, multi = props.multi, onBlurProp = props.onBlur, onChangeProp = props.onChange, onClearButtonClickedProp = props.onClearButtonClicked, onClickProp = props.onClick, onCloseProp = props.onClose, onCreateOptionProp = props.onCreateOption, _h = props.onCreateOptionFromRawValue, onCreateOptionFromRawValue = _h === void 0 ? DEFAULT_ON_CREATE_OPTION_FROM_RAW_VALUE : _h, onFocusProp = props.onFocus, onKeyDownProp = props.onKeyDown, onOpenProp = props.onOpen, onSearchInputChange = props.onSearchInputChange, openProp = props.open, optionsProp = props.options, rawValueProp = props.rawValue, recentlySelectedGroupLabelProp = props.recentlySelectedGroupLabel, searchableProp = props.searchable, _j = props.showRecentlySelected, showRecentlySelectedProp = _j === void 0 ? 'never' : _j, sortGroupsProp = props.sortGroups, sortOptionsProp = props.sortOptions, valueProp = props.value;
    /** A map of option values computed in the current life cycle, hashed by the option from which the value was computed */
    var valuesHashedByOption = new Map();
    var valuesHashedByOptionRef = React.useRef(valuesHashedByOption);
    valuesHashedByOptionRef.current = valuesHashedByOption;
    /**
     * A wrapper on top of getOptionValueProp that ensures we only ever compute an option's value once for
     * any unique option, since the computation may return a different instance of a rawValue on every call.
     */
    var getOptionValue = React.useCallback(function (opt) {
        var hashedOptionValue = valuesHashedByOptionRef.current.get(opt);
        if (hashedOptionValue) {
            return hashedOptionValue;
        }
        var optionValue = getOptionValueProp(opt);
        valuesHashedByOptionRef.current.set(opt, optionValue);
        return optionValue;
    }, [getOptionValueProp]);
    // hooks
    useDropdownPropWarnings(props);
    var checkIsMounted = useCheckIsMounted();
    var id = useId(dropdownDisplayName, { defaultId: idProp });
    var _k = useCoerceFilterOptionsAsyncProps(props), filterOnFocusBehavior = _k.callOnFocusBehavior, filterOnMountBehavior = _k.callOnMountBehavior, filterWhenQueryEmpty = _k.callWhenQueryEmpty;
    // context
    var groupContext = useFormGroupContext();
    // refs
    var dropdownTriggerRef = React.useRef(null);
    var footerRef = React.useRef(null);
    var getOptionDisabledRef = React.useRef(getOptionDisabled);
    var getOptionLabelRef = React.useRef(getOptionLabel);
    var getOptionValueRef = React.useRef(getOptionValue);
    var listRef = React.useRef(null);
    var searchInputRef = React.useRef(null);
    var virtualizedListRef = React.useRef(null);
    var virtuosoRef = React.useRef(null);
    var fetchOptionsAbortControllerRef = React.useRef(null);
    var onBlurPropRef = React.useRef();
    var onChangePropRef = React.useRef();
    var onClickPropRef = React.useRef();
    var onClearButtonClickedRef = React.useRef();
    var onCloseRef = React.useRef();
    var onCreateOptionPropRef = React.useRef();
    var onFocusPropRef = React.useRef();
    var onKeyDownPropRef = React.useRef();
    var onOpenRef = React.useRef();
    var onSearchInputChangeRef = React.useRef();
    var optionsPropRef = React.useRef();
    var queryRef = React.useRef('');
    var groupByRef = React.useRef();
    var sortGroupsPropRef = React.useRef();
    var sortOptionsPropRef = React.useRef();
    var valuePropRef = React.useRef();
    var filterOptionsRef = React.useRef();
    var filterOptionsAsyncRef = React.useRef();
    var handleFilterOptionsRef = React.useRef();
    var showRecentlySelectedPropRef = React.useRef(showRecentlySelectedProp);
    // "refifying" callback functions so, if they change in the middle of an async / await
    // they're updated without causing a hook to re-fire
    getOptionDisabledRef.current = getOptionDisabled;
    getOptionLabelRef.current = getOptionLabel;
    getOptionValueRef.current = getOptionValue;
    onBlurPropRef.current = onBlurProp;
    onChangePropRef.current = onChangeProp;
    onClearButtonClickedRef.current = onClearButtonClickedProp;
    onClickPropRef.current = onClickProp;
    onCloseRef.current = onCloseProp;
    onCreateOptionPropRef.current = onCreateOptionProp;
    onFocusPropRef.current = onFocusProp;
    onOpenRef.current = onOpenProp;
    onSearchInputChangeRef.current = onSearchInputChange;
    optionsPropRef.current = optionsProp;
    filterOptionsRef.current = filterOptionsProp;
    filterOptionsAsyncRef.current = filterOptionsAsyncProp;
    groupByRef.current = groupBy;
    sortGroupsPropRef.current = sortGroupsProp;
    sortOptionsPropRef.current = sortOptionsProp;
    valuePropRef.current = valueProp;
    showRecentlySelectedPropRef.current = showRecentlySelectedProp;
    // state
    var _l = __read(React.useState(false), 2), focused = _l[0], setFocused = _l[1];
    var _m = __read(React.useState(false), 2), loading = _m[0], setLoading = _m[1];
    var _o = __read(React.useState(''), 2), query = _o[0], setQuery = _o[1];
    var _p = __read(React.useState(INTERNAL_OPTIONS_NOT_USED), 2), internalOptions = _p[0], setInternalOptions = _p[1];
    var _q = __read(React.useState(INTERNAL_OPTIONS_NOT_USED), 2), internalFilteredOptions = _q[0], setInternalFilteredOptions = _q[1];
    var internalFilteredOptionsRef = React.useRef(internalFilteredOptions);
    internalFilteredOptionsRef.current = internalFilteredOptions;
    var _r = __read(React.useState([]), 2), selectedInternal = _r[0], setSelectedInternal = _r[1];
    var _s = __read(React.useState(-1), 2), selectedIndex = _s[0], setSelectedIndex = _s[1];
    // additional hooks
    var prevFocused = usePrevious(focused);
    var prevRawValueProp = usePrevious(rawValueProp);
    var prevValueProp = usePrevious(valueProp);
    var prevOptionsProp = usePrevious(optionsProp);
    // local variables
    //   Accessibility selectors
    queryRef.current = query;
    var areCurrentAndPreviousOptionsPropTheSame = !checkIsMounted() || checkOptionsEqual(optionsProp, prevOptionsProp);
    var areCurrentAndPreviousRawValuesTheSame = !checkIsMounted() || checkRawValuesEqual(rawValueProp, prevRawValueProp);
    var areCurrentAndPreviousValuePropTheSame = !checkIsMounted() || checkOptionsEqual(valueProp, prevValueProp);
    var a11yDropdownDescriptionId = "".concat(A11Y_HAWKINS_DROPDOWN_DESCRIBES_ID, "_").concat(id);
    var a11yDropdownTriggerLabelId = "".concat(A11Y_HAWKINS_DROPDOWN_TRIGGER_LABEL_ID, "_").concat(id);
    var a11yDropdownListId = "".concat(A11Y_HAWKINS_DROPDOWN_LIST_ID, "_").concat(id);
    //   Read from form group context, if it is inside a <FormGroup/>
    var disabled = groupContext.disabled || (disabledProp !== null && disabledProp !== void 0 ? disabledProp : false);
    var isGroupingEnabled = Boolean(groupBy);
    // pre-memos (dependent memos for other hooks in here)
    var rawValueIsControlled = 'rawValue' in props;
    var valueIsControlled = 'value' in props;
    var normalizedValueIsControlled = rawValueIsControlled || valueIsControlled;
    var optionsAreControlled = 'options' in props;
    /** The "source of truth" options are the baseline options to use for the current render cycle. This is either
     * optionsProp or internalOptions, depending on whether or not the optionsProp has changed this render cycle. */
    var sourceOfTruthOptions = optionsProp || STABLE_EMPTY_ARRAY;
    if (areCurrentAndPreviousOptionsPropTheSame && internalOptions) {
        sourceOfTruthOptions = internalOptions;
    }
    var prevSourceOfTruthOptions = usePrevious(sourceOfTruthOptions);
    var areCurrentAndPreviousSourceOfTruthOptionsTheSame = !checkIsMounted() || checkOptionsEqual(sourceOfTruthOptions, prevSourceOfTruthOptions);
    // Tracking normalized value and changes
    var normalizedRawValueRef = React.useRef(null);
    /** The valueProp, or the rawValueProp converted to a DropdownOptionType shape */
    var normalizedValue = normalizedRawValueRef.current;
    if (!checkIsMounted() ||
        !areCurrentAndPreviousSourceOfTruthOptionsTheSame ||
        !areCurrentAndPreviousRawValuesTheSame ||
        !areCurrentAndPreviousValuePropTheSame) {
        normalizedValue = rawValueIsControlled
            ? normalizeRawValue({
                checkRawValuesEqual: checkRawValuesEqual,
                getOptionValue: getOptionValue,
                onCreateOptionFromRawValue: onCreateOptionFromRawValue,
                options: sourceOfTruthOptions,
                rawValue: rawValueProp,
            })
            : valueProp;
        normalizedRawValueRef.current = normalizedValue;
    }
    var normalizedValueAsArray = React.useMemo(function () { return (Array.isArray(normalizedValue) ? normalizedValue : normalizedValue ? [normalizedValue] : []); }, [normalizedValue]);
    /** The options that are deemed "selected" this render cycle */
    var selectedOptions = React.useMemo(function () {
        return normalizedValueIsControlled ? normalizedValueAsArray : selectedInternal;
    }, [normalizedValueAsArray, normalizedValueIsControlled, selectedInternal]);
    var prevSelectedOptions = usePrevious(selectedOptions);
    var areCurrentAndPreviousSelectedOptionsTheSame = !checkIsMounted() || checkOptionsEqual(selectedOptions, prevSelectedOptions);
    var selectedOptionsIds = React.useMemo(function () { return new Map(selectedOptions.map(function (opt) { return [getOptionValueRef.current(opt), opt]; })); }, [selectedOptions]);
    // Tracking options values and changes
    var optionsRef = React.useRef(STABLE_EMPTY_ARRAY);
    /** The "final" options to respect this render cycle, prior to any filtering that may reduce them further. */
    var options = optionsRef.current;
    if (!checkIsMounted() ||
        !areCurrentAndPreviousSourceOfTruthOptionsTheSame ||
        !areCurrentAndPreviousSelectedOptionsTheSame) {
        // Dedupe the merged selectedOptions and sourceOfTruthOptions, since selectedOptions could contain options
        // that are not in sourceOfTruthOptions (such as options that may have been created from normalizing
        // rawValue/value), each of which still need to be respected by the dropdown as an option to potentially
        // render.
        options = dedupeOptions(__spreadArray(__spreadArray([], __read(sourceOfTruthOptions), false), __read(selectedOptions), false), checkOptionsEqual);
        // Filter out any invalid options (options without labels)
        options = options.filter(function (o) { return getOptionLabelRef.current(o); });
        // Sort the options, if applicable:
        if (typeof sortOptionsPropRef.current === 'boolean') {
            options = options.sort(function (a, b) { return getOptionLabelRef.current(a).localeCompare(getOptionLabelRef.current(b)); });
        }
        else if (typeof sortOptionsPropRef.current === 'function') {
            options = options.sort(sortOptionsPropRef.current);
        }
        optionsRef.current = options;
    }
    /**
     * The "final" options to respect this render cycle, after any filtering that may have reduced them further.
     * These are the options to be displayed in the Dropdown menu during the current render cycle.
     */
    var optionsToDisplay = internalFilteredOptions || options;
    /** Whether or not the optionsToDisplay array has something in it */
    var hasOptionsToDisplay = optionsToDisplay.length > 0;
    /** Whether or not the options array has something in it */
    var hasOptions = options.length > 0;
    var optionsToDisplayByGroup = React.useMemo(function () {
        var e_1, _a, e_2, _b;
        if (!groupByRef.current)
            return null;
        var currentGroupBy = groupByRef.current;
        var grouped = optionsToDisplay.reduce(function (prev, opt) {
            var _a;
            var _b;
            var groupName = currentGroupBy(opt) || translate('dropdown.list.ungrouped.header');
            var existing = (_b = prev[groupName]) !== null && _b !== void 0 ? _b : [];
            return __assign(__assign({}, prev), (_a = {}, _a[groupName] = __spreadArray(__spreadArray([], __read(existing), false), [opt], false), _a));
        }, {});
        if (typeof sortGroupsPropRef.current === 'boolean' && Boolean(sortGroupsPropRef.current)) {
            var out = {};
            try {
                for (var _c = __values(Object.keys(grouped).sort(function (a, b) { return a.localeCompare(b); })), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var group = _d.value;
                    out[group] = grouped[group];
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return out;
        }
        if (typeof sortGroupsPropRef.current === 'function') {
            var out = {};
            try {
                for (var _e = __values(Object.keys(grouped).sort(sortGroupsPropRef.current)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var group = _f.value;
                    out[group] = grouped[group];
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return out;
        }
        return grouped;
    }, [optionsToDisplay, translate]);
    var shouldFilterOnMount = filterOnMountBehavior === 'always' || (!hasOptions && filterOnMountBehavior === 'when-no-options');
    // callbacks
    /**
     * Resets the selected index used for highlighting the options list for the keyboard users
     */
    var resetSelectedIndex = React.useCallback(function () { return setSelectedIndex(-1); }, []);
    /**
     * Called either when user types in the Dropdown's filter text input,
     * or explicitly with an empty value after a user has clicked on the "create XXX" footer
     */
    var handleUpdateQuery = React.useCallback(function (eOrQuery) {
        var _a;
        var value = typeof eOrQuery === 'string' ? eOrQuery : eOrQuery.target.value;
        var nonSpaceVal = value.replace(/\s+/, '');
        // if this value is exclusively empty characters, don't update the query
        if (value.length && !nonSpaceVal.length)
            return;
        (_a = onSearchInputChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onSearchInputChangeRef, value);
        setQuery(value);
        resetSelectedIndex(); // always reset the selection because the options probably changed
    }, [resetSelectedIndex]);
    /**
     * Utility function to focus the search input, if it is available
     */
    var handleFocusSearchInput = React.useCallback(function () {
        // we perform this out of the render context to give React time to "catch up" with its DOM references
        setTimeout(function () {
            var _a, _b, _c;
            (_c = ((_b = (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) !== null && _b !== void 0 ? _b : searchInputRef.current)) === null || _c === void 0 ? void 0 : _c.focus();
        }, 0);
    }, []);
    /**
     * Utility function to focus the dropdown trigger
     */
    var handleFocusDropdownTrigger = React.useCallback(function () {
        // we perform this out of the render context to give React time to "catch up" with its DOM references
        setTimeout(function () {
            var _a, _b, _c;
            (_c = ((_b = (_a = dropdownTriggerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) !== null && _b !== void 0 ? _b : dropdownTriggerRef.current)) === null || _c === void 0 ? void 0 : _c.focus();
        }, 0);
    }, []);
    /**
     * Utility callback that disabled the dropdown's focus
     * and calls any onClose handlers that exist
     */
    var handleCloseDropdown = React.useCallback(function (ignoreFocusState) {
        var _a;
        if (ignoreFocusState === void 0) { ignoreFocusState = false; }
        (_a = onCloseRef.current) === null || _a === void 0 ? void 0 : _a.call(onCloseRef);
        if (!ignoreFocusState) {
            setFocused(false);
        }
        setSelectedIndex(-1);
        if (clearSearchOnClose)
            handleUpdateQuery('');
    }, [clearSearchOnClose, handleUpdateQuery]);
    /**
     * Called when a user clicks on the "X" button to clear their input value (when clearable is true)
     */
    var handleClearInput = React.useCallback(function (e) {
        var _a, _b;
        // detail will be the number of clicks that triggered,
        // which is usually 1 for a mouse, and always 0 for a keyboard "click"
        // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
        var isKeyboardClear = !e.detail;
        (_a = onClearButtonClickedRef.current) === null || _a === void 0 ? void 0 : _a.call(onClearButtonClickedRef, e);
        (_b = onChangePropRef.current) === null || _b === void 0 ? void 0 : _b.call(onChangePropRef, (multi ? [] : undefined));
        if (isKeyboardClear)
            handleFocusDropdownTrigger(); // refocus the dropdown
        if (autoComplete)
            handleUpdateQuery(''); // blast away the query but only for autocompletes
        if (normalizedValueIsControlled)
            return;
        setSelectedInternal([]);
    }, [autoComplete, handleFocusDropdownTrigger, handleUpdateQuery, multi, normalizedValueIsControlled]);
    /**
     * Called exclusively by the "handleFilterOptions" callback,
     * this sets up an abortable operation that will be aborted
     * if an outstanding async filter operation has not yet completed
     * by the time a user updates the dropdown's text input query
     */
    var handleAbort = React.useCallback(function (query, resolve) {
        var _a;
        // Abort any outstanding operations
        (_a = fetchOptionsAbortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        var abortController = new AbortController();
        fetchOptionsAbortControllerRef.current = abortController;
        var abortCallback = function () {
            logToConsole("Aborting filtering of options for query \"".concat(query, "\""), {
                displayName: dropdownDisplayName,
                level: 'warn',
            });
            resolve(null);
            abortController.signal.removeEventListener('abort', abortCallback);
        };
        abortController.signal.addEventListener('abort', abortCallback);
        return abortController;
    }, []);
    /**
     * Performs the selection or removal of any options that
     * a user is selecting as the value of this Dropdown
     */
    var handleSelected = React.useCallback(function (_a) {
        var _b;
        var option = _a.option, _c = _a.remove, remove = _c === void 0 ? false : _c;
        var didClose = false;
        if (!multi && !autoComplete) {
            didClose = true;
            handleCloseDropdown();
        }
        var newVal = [];
        if (multi) {
            if (remove) {
                newVal = selectedOptions.filter(function (v) { return !checkOptionsEqual(v, option); });
            }
            else {
                var existingSelectedOptionIndex = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.findIndex(function (so) { return checkOptionsEqual(so, option); });
                if (existingSelectedOptionIndex >= 0) {
                    newVal = __spreadArray([], __read(selectedOptions), false);
                    newVal.splice(existingSelectedOptionIndex, 1, option);
                }
                else {
                    newVal = __spreadArray(__spreadArray([], __read(selectedOptions), false), [option], false);
                }
            }
        }
        else {
            newVal = option;
        }
        // always attempt to call the onChange
        (_b = onChangePropRef.current) === null || _b === void 0 ? void 0 : _b.call(onChangePropRef, newVal);
        if (clearSearchOnSelect)
            handleUpdateQuery('');
        // let's refocus the dropdown itself so the tabindex
        // keeps working as people would expect
        if (!didClose && !autoComplete && (creatable || searchableProp))
            handleFocusSearchInput();
        else
            handleFocusDropdownTrigger();
        var newSelectedInternal = Array.isArray(newVal) ? newVal : [newVal];
        return setSelectedInternal(newSelectedInternal);
    }, [
        autoComplete,
        checkOptionsEqual,
        clearSearchOnSelect,
        creatable,
        handleCloseDropdown,
        handleFocusDropdownTrigger,
        handleFocusSearchInput,
        handleUpdateQuery,
        multi,
        searchableProp,
        selectedOptions,
    ]);
    /**
     * Called when the Dropdown's filter text input focus is lost
     */
    var handleBlur = React.useCallback(function (e) {
        var _a;
        resetSelectedIndex();
        if (disabled)
            return;
        return (_a = onBlurPropRef.current) === null || _a === void 0 ? void 0 : _a.call(onBlurPropRef, e);
    }, [disabled, resetSelectedIndex]);
    /**
     * Called when the any part of the Dropdown's trigger is clicked
     */
    var handleClick = React.useCallback(function (e) {
        var _a;
        if (disabled)
            return;
        var newFocused = !focused;
        setFocused(newFocused);
        if (newFocused && !searchableProp)
            handleFocusDropdownTrigger();
        return (_a = onClickPropRef.current) === null || _a === void 0 ? void 0 : _a.call(onClickPropRef, e);
    }, [disabled, focused, handleFocusDropdownTrigger, searchableProp]);
    // callbacks (more of them)
    /**
     * Called when the Dropdown's filter text input is focused
     */
    var handleFocus = React.useCallback(function (e) {
        var _a;
        if (disabled)
            return;
        return (_a = onFocusPropRef.current) === null || _a === void 0 ? void 0 : _a.call(onFocusPropRef, e);
    }, [disabled]);
    /**
     * Called when the a keyboard button is pressed
     * while a user has focused the Dropdown
     */
    var handleKeyDown = React.useCallback(function (e) {
        var _a, _b, _c;
        if (disabled)
            return;
        switch (e.key) {
            case KeyAttributeValue.SPACE:
                // prevent the spacebar from bubbling up and triggering a false click
                // if the trigger isn't an input element
                var inputTgt = e.target; // is there a better way to do this?
                if (inputTgt.tagName.toLowerCase() !== 'input' || inputTgt.readOnly || inputTgt.disabled) {
                    e.preventDefault();
                }
                setFocused(true);
                break;
            case KeyAttributeValue.ARROW_DOWN: {
                e.preventDefault();
                // move the highlighted option upwards
                setFocused(true);
                var nextIndex = Math.min(selectedIndex + 1, optionsToDisplay.length - 1);
                if (selectedIndex + 1 >= optionsToDisplay.length && creatable && query) {
                    // we should transition to the creatable footer, if it exists
                    var creatableFooter = (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("[".concat(creatableFooterDataSelector, "]"));
                    if (!creatableFooter)
                        return setSelectedIndex(nextIndex);
                    creatableFooter.focus();
                    setSelectedIndex(nextIndex + 1); // set the index to one greater than the maximum allowed
                }
                else
                    setSelectedIndex(nextIndex);
                break;
            }
            case KeyAttributeValue.ARROW_UP: {
                e.preventDefault();
                // move the highlighted option downwards
                setFocused(true);
                var nextIndex = Math.max(selectedIndex - 1, 0);
                setSelectedIndex(nextIndex);
                break;
            }
            case KeyAttributeValue.ENTER: {
                // select the value
                var opts_1 = optionsToDisplayByGroup ? Object.values(optionsToDisplayByGroup).flat() : optionsToDisplay;
                var optToSelect = opts_1[selectedIndex];
                if (!optToSelect || ((_b = getOptionDisabledRef.current) === null || _b === void 0 ? void 0 : _b.call(getOptionDisabledRef, optToSelect)))
                    return;
                handleSelected({
                    option: optToSelect,
                    remove: selectedOptions.some(function (opt) { return checkOptionsEqual(opt, opts_1[selectedIndex]); }),
                });
                if (autoComplete)
                    handleCloseDropdown();
                else if (!multi)
                    e.currentTarget.blur();
                break;
            }
            case KeyAttributeValue.ESCAPE:
            case KeyAttributeValue.TAB:
                // Close the dropdown and attempt to switch focus to the next
                // tabbable thing
                handleCloseDropdown();
                // the autocomplete is technically an <input type="text" />
                // so let's just keep focus on the input and let the browser
                // figure out how to transition focus
                if (!autoComplete)
                    e.currentTarget.blur();
                break;
            default:
                break;
        }
        return (_c = onKeyDownPropRef.current) === null || _c === void 0 ? void 0 : _c.call(onKeyDownPropRef, e);
    }, [
        autoComplete,
        checkOptionsEqual,
        creatable,
        disabled,
        handleCloseDropdown,
        handleSelected,
        multi,
        optionsToDisplay,
        optionsToDisplayByGroup,
        query,
        selectedIndex,
        selectedOptions,
    ]);
    var handleCreatableFooterKeydown = React.useCallback(function (e) {
        if (e.key !== KeyAttributeValue.ARROW_UP)
            return;
        e.preventDefault();
        setSelectedIndex(function (prev) { return Math.max(prev - 1, optionsToDisplay.length - 1); });
        handleFocusSearchInput();
    }, [optionsToDisplay.length, handleFocusSearchInput]);
    /**
     * Delegates any Dropdown filter text input change events to the handleUpdateQuery callback
     */
    var handleInputChange = React.useCallback(function (e) {
        if (disabled)
            return;
        if (autoComplete)
            setFocused(true);
        return handleUpdateQuery(e);
    }, [autoComplete, disabled, handleUpdateQuery]);
    /**
     * Called on any mouse event, this function
     * will close the currently-active dropdown if
     * the event didn't emanate from the Dropdown or its options list
     */
    var handleOutsideClick = React.useCallback(function (e) {
        if (!focused)
            return;
        var isDropdown = isTargetChildOfElementId(e, id);
        if (isDropdown) {
            handleCloseDropdown(true);
            return;
        }
        handleCloseDropdown();
    }, [focused, handleCloseDropdown, id]);
    /**
     * Called whenever creatable is true and the user
     * clicks on the "create XXX" option footer
     */
    var handleCreateNewOption = React.useCallback(function (newOptText) {
        var _a, _b, _c, _d;
        if (!newOptText)
            return;
        var defaultNewOpt = {
            label: newOptText,
            newOption: true,
            value: newOptText,
        };
        var newOpt = (_b = (_a = onCreateOptionPropRef.current) === null || _a === void 0 ? void 0 : _a.call(onCreateOptionPropRef, newOptText, defaultNewOpt)) !== null && _b !== void 0 ? _b : defaultNewOpt;
        // If the consumer returned null from onCreateOption, it means they intend to fully control
        // the created option and its selected state themselves, so we bail and hand it over to them
        // at this point:
        if (newOpt === DROPDOWN_ON_CREATE_OPTION_NULL)
            return;
        var existingOptionWithCreatedRawValueIndex = optionsRef.current.findIndex(function (opt) {
            return checkRawValuesEqual(getOptionValueRef.current(opt), getOptionValueRef.current(newOpt));
        });
        // If there is already an existing option whose rawValue is equal to the newly created option's,
        // then we replace the existing option with the new one. Otherwise we append the newly created
        // option.
        if (existingOptionWithCreatedRawValueIndex >= 0) {
            var newInternalOptions = __spreadArray([], __read((optionsRef.current || [])), false);
            newInternalOptions.splice(existingOptionWithCreatedRawValueIndex, 1, newOpt);
            setInternalOptions(newInternalOptions);
            var existingFilteredOptionWithCreatedRawValueIndex = (_d = (_c = internalFilteredOptionsRef.current) === null || _c === void 0 ? void 0 : _c.findIndex(function (opt) {
                return checkRawValuesEqual(getOptionValueRef.current(opt), getOptionValueRef.current(newOpt));
            })) !== null && _d !== void 0 ? _d : -1;
            if (existingFilteredOptionWithCreatedRawValueIndex >= 0) {
                var newInternalFilteredOptions = __spreadArray([], __read((internalFilteredOptionsRef.current || [])), false);
                newInternalFilteredOptions.splice(existingOptionWithCreatedRawValueIndex, 1, newOpt);
                setInternalFilteredOptions(newInternalFilteredOptions);
            }
            else {
                setInternalFilteredOptions(__spreadArray(__spreadArray([], __read((internalFilteredOptionsRef.current || [])), false), [newOpt], false));
            }
        }
        else {
            setInternalOptions(__spreadArray(__spreadArray([], __read((optionsRef.current || [])), false), [newOpt], false));
            setInternalFilteredOptions(__spreadArray(__spreadArray([], __read((internalFilteredOptionsRef.current || [])), false), [newOpt], false));
        }
        // Need to set this newly-created option
        // as the value, so let's also fire the handleSelected function and clear the search query.
        handleSelected({ option: newOpt });
        if (clearSearchOnSelect)
            handleUpdateQuery('');
        return newOpt;
    }, [checkRawValuesEqual, clearSearchOnSelect, handleSelected, handleUpdateQuery]);
    /** Handles filtering the options internally, building on the consumer's filterOptions if provided. */
    handleFilterOptionsRef.current = function (query) {
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var abortController, updatedInternalFilteredOptions, filterFunction, response, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, , 5]);
                        abortController = handleAbort(query, resolve);
                        updatedInternalFilteredOptions = INTERNAL_OPTIONS_NOT_USED;
                        if (!(filterWhenQueryEmpty || query)) return [3 /*break*/, 3];
                        filterFunction = (_b = (_a = filterOptionsAsyncRef.current) !== null && _a !== void 0 ? _a : filterOptionsRef.current) !== null && _b !== void 0 ? _b : GET_DEFAULT_FILTER_OPTIONS(options, getOptionLabelRef.current, getOptionValueRef.current);
                        response = filterFunction(query, options !== null && options !== void 0 ? options : []);
                        if (!(response instanceof Promise)) return [3 /*break*/, 2];
                        setLoading(true);
                        return [4 /*yield*/, response];
                    case 1:
                        updatedInternalFilteredOptions = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        updatedInternalFilteredOptions = response;
                        _c.label = 3;
                    case 3:
                        // User returned nothing or the request was aborted
                        if (abortController.signal.aborted || !updatedInternalFilteredOptions) {
                            // need to turn the loading bar off if a user had a query and deleted it all
                            // otherwise the component will show an infinite loading state
                            if (!filterWhenQueryEmpty)
                                setLoading(false);
                            return [2 /*return*/];
                        }
                        setLoading(false);
                        if (!optionsAreControlled) {
                            setInternalOptions(updatedInternalFilteredOptions);
                        }
                        setInternalFilteredOptions(updatedInternalFilteredOptions);
                        resolve(updatedInternalFilteredOptions);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _c.sent();
                        reject(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); });
    };
    // This function creates an array of recently selected options based on the value of selectedOptionsIds.
    // It also returns a lookup table for options to query them in constant time.
    var processRecentlySelectedOptions = React.useCallback(function (enableGrouping, queryOptions) {
        var e_3, _a;
        var _b;
        if (queryOptions === void 0) { queryOptions = { enable: false, filter: '' }; }
        var recentlySelectedOptions = [];
        var lookup = new Set();
        // Note: recently selected group label title will only appear in the UI if grouping is enabled.
        var recentlySelectedGroupLabel = (_b = recentlySelectedGroupLabelProp !== null && recentlySelectedGroupLabelProp !== void 0 ? recentlySelectedGroupLabelProp : translate === null || translate === void 0 ? void 0 : translate('dropdown.list.group.header.empty.label')) !== null && _b !== void 0 ? _b : '';
        var previousSelectedOptions = [];
        try {
            for (var _c = __values(selectedOptionsIds.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var selectedOption = _d.value;
                var optionLabel = getOptionLabelRef.current ? getOptionLabelRef.current(selectedOption) : null;
                if (queryOptions.enable &&
                    typeof optionLabel === 'string' &&
                    optionLabel.toLocaleLowerCase().includes(queryOptions.filter.toLocaleLowerCase()) === false) {
                    continue;
                }
                previousSelectedOptions.push(selectedOption);
                lookup.add(getOptionValueRef.current(selectedOption));
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
        if (enableGrouping) {
            if (!queryOptions.enable || (queryOptions.enable && previousSelectedOptions.length > 0)) {
                recentlySelectedOptions.push(recentlySelectedGroupLabel);
            }
        }
        recentlySelectedOptions.push.apply(recentlySelectedOptions, __spreadArray([], __read(previousSelectedOptions), false));
        return { options: recentlySelectedOptions, lookup: lookup };
    }, [recentlySelectedGroupLabelProp, selectedOptionsIds, translate]);
    // memos
    /**
     * We compute recently selected options here for cases in which consumers pass non function values to showRecentlySelectedProp. Otherwise this function will return null.
     * If showRecentlySelected is enabled we create an array with a custom group title and the previous selected options following the same pattern as the
     * 'default' options.
     * This also returns a lookup table to filter options later with a O(1) check for the single dropdown case, given that we don't want to render options
     * twice in that scenario.
     */
    var internalComputedRecentSelected = React.useMemo(function () {
        if (showRecentlySelectedProp === false || showRecentlySelectedProp === 'never') {
            return { options: [], lookup: new Set() };
        }
        if ((showRecentlySelectedProp === true || showRecentlySelectedProp === 'always') && selectedOptionsIds.size) {
            return processRecentlySelectedOptions(isGroupingEnabled);
        }
        if (showRecentlySelectedProp === 'only-when-empty-query' && query === '' && selectedOptionsIds.size) {
            return processRecentlySelectedOptions(isGroupingEnabled);
        }
        if (showRecentlySelectedProp === 'filtered-by-query' && selectedOptionsIds.size) {
            return processRecentlySelectedOptions(isGroupingEnabled, { enable: true, filter: query });
        }
        return null;
    }, [isGroupingEnabled, processRecentlySelectedOptions, query, selectedOptionsIds.size, showRecentlySelectedProp]);
    /* This value is the result of the recently selected options computed by the controlled version of the showRecentlySelectedProp. */
    var consumerComputedRecentSelected = React.useMemo(function () {
        if (typeof showRecentlySelectedPropRef.current === 'function' &&
            selectedOptionsIds.size &&
            optionsToDisplay &&
            optionsToDisplay.length > 0) {
            // First get all the internally processed recently selected options.
            var recentlySelectedResult = processRecentlySelectedOptions(isGroupingEnabled);
            // Then remove the options that are group titles.
            var recentlySelectedOptions = recentlySelectedResult.options.filter(function (option) { return typeof option !== 'string'; });
            // After filtering titles, this will call the consumer function that handles options to display and recently selected options.
            var userProcessedRecentlySelectedOptions = showRecentlySelectedPropRef.current(query, optionsToDisplay, recentlySelectedOptions);
            // This line creates a lookup set based on the options that the user returned. (needed to match internalComputedRecentSelected return type)
            var lookup = new Set(userProcessedRecentlySelectedOptions.map(function (option) { return getOptionValueRef.current(option); }));
            // Finally this builds the resulting options along and append the recently selected options group title.
            var finalOptions = __spreadArray(__spreadArray([], __read(recentlySelectedResult.options.filter(function (option) { return typeof option === 'string'; })), false), __read(userProcessedRecentlySelectedOptions), false);
            return { options: finalOptions, lookup: lookup };
        }
        return null;
    }, [isGroupingEnabled, optionsToDisplay, processRecentlySelectedOptions, query, selectedOptionsIds.size]);
    /** The "final" recently selected options to be provided to the Dropdown */
    var computedRecentSelected = React.useMemo(function () {
        var _a;
        return ((_a = (typeof showRecentlySelectedProp === 'function'
            ? consumerComputedRecentSelected
            : internalComputedRecentSelected)) !== null && _a !== void 0 ? _a : {
            options: [],
            lookup: new Set(),
        });
    }, [consumerComputedRecentSelected, internalComputedRecentSelected, showRecentlySelectedProp]);
    // effects
    React.useEffect(function () {
        /**
         * on any query change or selected options change (it's possible a user created a brand-new option),
         * we need to make sure the options are updated.
         * this works as desired, because this ensures all options setting
         * and value selection fires BEFORE we attempt to update the options that are displayed.
         * If we were to perform this strictly in a callback, we may run into
         * a "behind-by-one" state bug (try putting this function inside the
         * handleCreateNewOption callback above, for example)
         */
        var _a, _b;
        // first, we handle the special mount case
        if (searchableProp || autoComplete) {
            if (!checkIsMounted()) {
                if (shouldFilterOnMount)
                    (_a = handleFilterOptionsRef.current) === null || _a === void 0 ? void 0 : _a.call(handleFilterOptionsRef, query);
            }
            else
                (_b = handleFilterOptionsRef.current) === null || _b === void 0 ? void 0 : _b.call(handleFilterOptionsRef, query);
        }
    }, [autoComplete, checkIsMounted, filterOnMountBehavior, query, searchableProp, shouldFilterOnMount]);
    React.useEffect(function () {
        /**
         * Whenever a user uses the up or down arrows on their keyboard,
         * we will update the "selectedIndex" value in the keydown handler.
         * This effect will detect those changes and attempt to scroll the options
         * list to ensure the option a user has keyboarded to is visible in the options list.
         */
        var listContainer = virtualizedListRef.current;
        if (selectedIndex < 0 || !listContainer)
            return;
        var highlightedItem = listContainer.querySelector('[aria-selected=true]');
        // we should scroll with the Virtuoso functions
        if (virtuosoRef.current)
            return virtuosoRef.current.scrollIntoView({ behavior: 'smooth', index: selectedIndex });
        highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }, [selectedIndex]);
    /**
     * To be fired ONLY on the initial render,
     * if initialIsOpen === true, we open the dropdown
     */
    React.useEffect(function () {
        if (initialIsOpen)
            setFocused(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(function () {
        // Only allow for controlled open when there is no initialIsOpen prop
        if (isNil(initialIsOpen)) {
            setFocused(!!openProp);
        }
    }, [openProp, initialIsOpen]);
    /**
     * Special case if a user focused the dropdown,
     * we check their intentions to see if we should call the filterOptions
     * function.
     */
    React.useEffect(function () {
        var _a, _b;
        // we only care if we were recently focused
        if (!focused || (focused && prevFocused))
            return;
        (_a = onOpenRef.current) === null || _a === void 0 ? void 0 : _a.call(onOpenRef);
        if (filterOnFocusBehavior === 'always' || (filterOnFocusBehavior === 'when-no-options' && !options.length)) {
            (_b = handleFilterOptionsRef.current) === null || _b === void 0 ? void 0 : _b.call(handleFilterOptionsRef, query);
        }
    }, [filterOnFocusBehavior, focused, options.length, prevFocused, query]);
    /**
     * This effect resynchronizes the dropdown options with internal state,
     * if the options are controlled. You'll note that we are actually
     * reading the query value from a ref. This helps prevent excessive executions
     * of this effect. We are also leveraging deep equality checks
     * to validate that the props actually did change between renders
     */
    React.useEffect(function () {
        var _a;
        if (checkIsMounted() && optionsAreControlled && !areCurrentAndPreviousOptionsPropTheSame) {
            // we blast away our internally-managed options
            // to enforce that the options from props are always being taken as the source of truth
            // if it changes to something that is controlled
            setInternalOptions(INTERNAL_OPTIONS_NOT_USED);
            setInternalFilteredOptions(INTERNAL_OPTIONS_NOT_USED);
            (_a = handleFilterOptionsRef.current) === null || _a === void 0 ? void 0 : _a.call(handleFilterOptionsRef, queryRef.current);
        }
    }, [areCurrentAndPreviousOptionsPropTheSame, checkIsMounted, optionsAreControlled]);
    // final output
    return React.useMemo(function () { return ({
        a11yDropdownDescriptionId: a11yDropdownDescriptionId,
        a11yDropdownListId: a11yDropdownListId,
        a11yDropdownTriggerLabelId: a11yDropdownTriggerLabelId,
        computedRecentSelected: computedRecentSelected,
        disabled: disabled,
        dropdownTriggerRef: dropdownTriggerRef,
        focused: focused,
        footerRef: footerRef,
        getOptionValue: getOptionValue,
        handleClearInput: handleClearInput,
        handleSelected: handleSelected,
        handleBlur: handleBlur,
        handleClick: handleClick,
        handleCreateNewOption: handleCreateNewOption,
        handleCreatableFooterKeydown: handleCreatableFooterKeydown,
        handleFocus: handleFocus,
        handleKeyDown: handleKeyDown,
        handleInputChange: handleInputChange,
        handleOutsideClick: handleOutsideClick,
        hasOptions: hasOptionsToDisplay,
        id: id,
        loading: loading,
        listRef: listRef,
        options: optionsToDisplay,
        optionsByGroup: optionsToDisplayByGroup,
        query: query,
        searchInputRef: searchInputRef,
        selectedIndex: selectedIndex,
        selectedOptions: selectedOptions,
        selectedOptionsIds: selectedOptionsIds,
        virtualizedListRef: virtualizedListRef,
        virtuosoRef: virtuosoRef,
    }); }, [
        a11yDropdownDescriptionId,
        a11yDropdownListId,
        a11yDropdownTriggerLabelId,
        computedRecentSelected,
        disabled,
        focused,
        getOptionValue,
        handleBlur,
        handleClearInput,
        handleClick,
        handleCreatableFooterKeydown,
        handleCreateNewOption,
        handleFocus,
        handleInputChange,
        handleKeyDown,
        handleOutsideClick,
        handleSelected,
        hasOptionsToDisplay,
        id,
        loading,
        optionsToDisplay,
        optionsToDisplayByGroup,
        query,
        selectedIndex,
        selectedOptions,
        selectedOptionsIds,
    ]);
}
